import React, { useRef, useEffect, useState, useContext, useReducer, useCallback } from "react";
import './dinoContainer.css';


export const DinoRadio = ({radio_data,onChildClick}) => {
    console.log('component refresh1345 radio_data nw')
    console.log(radio_data)
    let initialState = {
        loading: false,
        error: false,
        my_data: [
            {
                "name": "Bob",
                "selected": true,
                "age": 23,
                "species": "T. Rex"
            },
            {
                "name": "Dylan",
                "selected": false,
                "age": 44,
                "species": "Bracchio"
            },
            {
                "name": "Kate",
                "selected": false,
                "age": 32,
                "species": "Stego"
            },
            {
                "name": "Sally",
                "selected": false,
                "age": 13,
                "species": "T. Rex"
            }
        ]
    }


    const getMyHtml = () => {
       /* const radio_data= [
            {
                "name": "1",
                "id": 1,
                "selected": true,
                "age": 23,
                "species": "T. Rex"
            },
            {
                "name": "2",
                "id": 2,
                "selected": false,
                "age": 44,
                "species": "Bracchio"
            },
            {
                "name": "3",
                "id": 3,
                "selected": false,
                "age": 32,
                "species": "Stego"
            },
            {
                "name": "4",
                "id": 4,
                "selected": false,
                "age": 13,
                "species": "T. Rex"
            }
        ]
   */
        return radio_data.map(o => {
            console.log(o)
            if (o.selected === false){
                return        (<div className="c-box">
                <a onClick={ (e)=>{onChildClick(o,e)} }> <span  className="c-span">{o.id}</span></a> 
              </div>)
            }else{
                return        (<div className="c-box">
                <a onClick={ (e)=>{onChildClick(o,e)} }> <span  className="c-span svactive">{o.id}</span></a> 
              </div>)
            }
           
        });
    }

    return (
        <div>
            <h3>Janu Radios</h3>
           
            <div className="c-container">
                {getMyHtml()}
                {/* 
                            <div className="c-box">
                                <span className="c-span">1</span>
                            </div>
                            <div className="c-box">
                                <span className="c-span">2</span>
                            </div>
                            <div className="c-box">
                                <span className="c-span">3</span>
                            </div>
                            <div className="c-box">
                                <span className="c-span">4</span>
                            </div>
                            <div className="c-box">
                                <span className="c-span">5</span>
                            </div>
                            <div className="c-box">
                                <span className="c-span">6</span>
                            </div>
                            <div className="c-box">
                                <span className="c-span">7</span>
                            </div>
                            <div className="c-box">
                                <span className="c-span">8</span>
                            </div>
                             */}
            </div>
        </div>
    )
}